import React, { useEffect, useState } from "react";
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
} from "@syncfusion/ej2-react-grids";

import { employeesData, employeesGrid } from "../data/dummy";
import { Header } from "../components";
import { CircularProgress, Button } from "@mui/material";
import Create from "../components/Colaboradores/Create";
import api from "../api/api";
import Alerts from "../components/Alerts";
import EditClient from "../components/Colaboradores/Edit";
import ClientTable from "../components/Clientes/Tabela";
import EmployeesTable from "../components/Colaboradores/Tabela";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";

const EmployeesPage = () => {
  const [customersData, setCustomersData] = useState([]);
  const [userToEdit, setUserToEdit] = useState({});
  const [step, setStep] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const fetchAdmins = async () => {
    setIsLoading(true);
    try {
      const res = await api.get("/users?take=900000");
      if (res.status === 200) {
        const admins = res.data.users.filter((user) => user.role === "ADMIN");
        setCustomersData(admins);
      } else {
        setCustomersData([]);
      }
    } catch (error) {
      setWarning({
        type: "error",
        message: "Erro ao carregar os colaboradores.",
      });
      handleOpenSnackbar();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleSave = async () => {
    await fetchAdmins();
    setStep("");
    setWarning({
      type: "success",
      message: "Lista de Colaboradores Atualizada!",
    });
    handleOpenSnackbar();
  };

  const handleEdit = (client) => {
    setUserToEdit(client);
    setStep("edit");
  };

  const handleUpdate = async (id, data) => {
    try {
      await api.put(`users/${id}`, data);
      setWarning({
        type: "success",
        message: "Colaborador Atualizado!",
      });
      handleOpenSnackbar();
      await fetchAdmins();
    } catch (error) {
      setWarning({
        type: "error",
        message: "Erro ao atualizar colaborador.",
      });
      handleOpenSnackbar();
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/users/${id}`);
      setWarning({
        type: "success",
        message: "Colaborador deletado com sucesso!",
      });
      handleOpenSnackbar();
      await fetchAdmins();
    } catch (error) {
      setWarning({
        type: "error",
        message: "Erro ao deletar colaborador.",
      });
      handleOpenSnackbar();
    }
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Administrativo" title="Colaboradores" />
      <div className="flex justify-between items-center mb-10">
        <Button
          onClick={() =>
            setStep(step === "create" || step === "edit" ? "" : "create")
          }
          variant="contained"
          color="primary"
          sx={{ mb: 5, width: "fit-content" }}
        >
          {step === "create" ? (
            <div className="flex items-center gap-2">
              <ArrowBackIcon />
              Voltar
            </div>
          ) : step === "edit" ? (
            <div className="flex items-center gap-2">
              <ArrowBackIcon />
              Voltar
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <AddIcon />
              Criar Novo Colaborador
            </div>
          )}
        </Button>
      </div>
      {isLoading ? (
        <div className="flex justify-center items-center h-40">
          <CircularProgress />
        </div>
      ) : step === "create" ? (
        <Create
          onSave={handleSave}
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
        />
      ) : step === "edit" ? (
        userToEdit && (
          <EditClient
            onClose={() => setStep("")}
            client={userToEdit}
            onSave={handleUpdate}
          />
        )
      ) : (
        <EmployeesTable
          clients={customersData}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      )}
      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};
export default EmployeesPage;
